import { FC, useEffect, useRef, useState } from "react";
import "./index.less";
import MainAdList from "./MainAdList";
import MainDeviceList from "./MainDeviceList";
import MainKoreaMap from "./MainKoreaMap";
import MainSummaryGraph from "./MainSummaryGraph";
import NoticeModal, { NoticeModalRef } from "./NoticeModal";
import TopNoticeList from "./TopNoticeList";

const DashBoardPage: FC = () => {
  const [loading, setLoading] = useState(true);
  const noticeModalRef = useRef<NoticeModalRef>();

  // mock timer to mimic dashboard data loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(undefined as any);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div
      className="dashboardRoot"
      style={{ paddingLeft: "40px", paddingRight: "40px" }}
    >
      <div
        style={{
          width: "99%",
          height: "24px",
          marginInline: "0.5%",
          marginBottom: "10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TopNoticeList noticeModalRef={noticeModalRef} />
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ width: "49.5%", marginRight: "1%" }}>
          <MainAdList />
        </div>
        <div style={{ width: "49.5%" }}>
          <MainDeviceList />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          paddingBottom: "20px",
          height: "400px",
        }}
      >
        <div style={{ flex: 3 }}>
          <MainSummaryGraph loading={loading} />
        </div>
        <div style={{ flex: 1 }}>
          <MainKoreaMap />
        </div>
      </div>
      <NoticeModal ref={noticeModalRef} />
    </div>
  );
};

export default DashBoardPage;
